import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Filled_Star from "../assets/Filled Star.png";
import Star from "../Component/Star.jsx";
import lock from "../assets/lock.jpg";
import unlock from "../assets/unlock.jpeg";

const EditPost = ({ refresh, loadPosts }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [postText, setPostText] = useState("");
    const [postTitle, setPostTitle] = useState("");
    const [postImage, setPostImage] = useState("");
    const [username, setUsername] = useState("");
    const [rating, setRating] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [privatePost, setPrivatePost] = useState(false);

    // Add state variables for restaurant and dish information
    const [restaurantName, setRestaurantName] = useState("");
    const [dishName, setDishName] = useState("");
    const [categories, setCategories] = useState([]);
    const [dishDescription, setDishDescription] = useState("");
    const [dishImage, setDishImage] = useState("");
    const [dishId, setDishId] = useState(null);
    const [dishDetails, setDishDetails] = useState(null);
    const [restaurantId, setRestaurantId] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [postAuth, setPostAuth] = useState("");

    const MAX_FILE_SIZE = 1024 * 1024;
    const MAX_TITLE_WORDS = 15;
    const MAX_REVIEW_WORDS = 250;
    const MAX_CHARACTER = 40;


    // const [isLoaded, setIsLoaded] = useState(false);
    // const [postAuth, setPostAuth] = useState("");

    const [showModal, setShowModal] = useState(false);
    const friendsID = sessionStorage.getItem("user");


    const { otherUserId } = useParams();
    const [followers, setFollowers] = useState([]);
    const [update, setUpdate] = useState(true);
    const userToken = sessionStorage.getItem("token");
    const userId = sessionStorage.getItem("user");



    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const basePath = isLocalhost ? "" : "https://webdev.cse.buffalo.edu/hci/teams/indecisive";

    const handleRatingChange = (newRating) => setRating(newRating);
    // const handlePrivacy = () => setPrivatePost(prev => !prev);

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        const headers = { "Content-Type": "application/json" };
        if (token) headers["Authorization"] = "Bearer " + token;

        // First set loading state
        setIsLoaded(false);
        console.log("Loading post data for editing...");

        // Only add Authorization if the user is logged in
        if (token) {
            headers["Authorization"] = "Bearer " + token;
        }

        fetch(`${process.env.REACT_APP_API_PATH}/posts/${id}`, { method: "GET", headers })
            .then(res => res.json())
            .then(async result => {
                if (result) {

                    // Set post basic information
                    setPostTitle(result.attributes?.title || "");
                    setPostText(result.content || "");
                    setPostAuth(result.authorID || "");
                    setUsername(result.attributes?.username || "Username");
                    setPrivatePost(result.attributes?.private || false);

                    // Ensure rating is properly converted to a number with fallbacks
                    const postRating = result.attributes?.overallRating !== undefined
                        ? Number(result.attributes.overallRating)
                        : 0;
                    console.log("Setting rating to:", postRating);
                    setRating(postRating);

                    // Handle post image
                    if (result.attributes?.image) {
                        let pictureURL;
                        if (result.attributes.image.startsWith("http")) {
                            pictureURL = result.attributes.image;
                        } else if (result.attributes.image.startsWith("/")) {
                            pictureURL = `${basePath}${result.attributes.image}`;
                        } else {
                            pictureURL = `https://webdev.cse.buffalo.edu${result.path}`;
                        }
                        setPostImage(pictureURL);
                    }

                    // Get the dish ID from the post and save it
                    const postDishId = result.attributes?.dishID;
                    setDishId(postDishId);
                    console.log("Post has dish ID:", postDishId);

                    try {
                        // Import the dishes data
                        const dishesData = await import('../assets/dishes2.json');
                        // Find the matching dish
                        const matchingDish = dishesData.default.find(d => d.id === Number(postDishId));

                        if (matchingDish) {
                            console.log("Found matching dish in dishes2.json:", matchingDish);
                            setDishDetails(matchingDish);
                            setRestaurantName(matchingDish.restaurantName || "Unknown Restaurant");
                            setDishName(matchingDish.title || "Unknown Dish");
                            setCategories(matchingDish.tags || []);
                            setDishDescription(matchingDish.description || "No description available");

                            try {
                                const resp = await fetch(
                                    isLocalhost ? "/data/restaurants.json" : `${basePath}/data/restaurants.json`
                                );
                                const restData = await resp.json();
                                const matchRest = restData.restaurants.find(r => r.name === matchingDish.restaurantName);
                                if (matchRest) setRestaurantId(matchRest.id);
                            } catch (e) {
                                console.error("Error loading restaurant data:", e);
                            }

                            if (matchingDish.image) {
                                const dishImageUrl = matchingDish.image.startsWith("/")
                                    ? `${basePath}${matchingDish.image}`
                                    : matchingDish.image;
                                setDishImage(dishImageUrl);
                                console.log("Setting dish image URL:", dishImageUrl);
                            } else if (result.attributes?.dishImage) {
                                setDishImage(result.attributes.dishImage);
                                console.log("Using dishImage from post attributes:", result.attributes.dishImage);
                            }
                        } else {
                            console.log("No matching dish found for ID:", postDishId);

                            // Use attributes from the post itself as fallback
                            setRestaurantName(result.attributes?.restaurant || "Unknown Restaurant");
                            setDishName(result.attributes?.title || "Unknown Dish");
                            setCategories(result.attributes?.tags || []);
                            setDishDescription(result.attributes?.description || "No description available");

                            // Try to get dishImage directly from post attributes
                            if (result.attributes?.dishImage) {
                                setDishImage(result.attributes.dishImage);
                                console.log("Setting dish image from post attributes:", result.attributes.dishImage);
                            }
                        }
                    } catch (e) {
                        console.error("Error loading dish data:", e);

                        // Fallback to using post attributes
                        setRestaurantName(result.attributes?.restaurant || "Unknown Restaurant");
                        setDishName(result.attributes?.title || "Unknown Dish");
                        setCategories(result.attributes?.tags || []);
                        setDishDescription(result.attributes?.description || "No description available");

                        if (result.attributes?.dishImage) {
                            setDishImage(result.attributes.dishImage);
                        }
                    }

                    setIsLoaded(true);
                }
            })
            .catch(err => {
                console.error("Error loading post for editing:", err);
                setIsLoaded(true);
            });
    }, [id, basePath, isLocalhost], [showModal]);

    const handleSave = e => {
        e.preventDefault();
        if (postTitle.split(/\s+/).length > MAX_TITLE_WORDS || postTitle.trim().length > MAX_CHARACTER) {
            setErrorMessage("Title cannot exceed 15 words or 40 characters.");
            return;
        }
        if (!postTitle.trim() || !postText.trim()) {
            setErrorMessage("Title and review are required.");
            return;
        }
        if (postText.trim().length > MAX_REVIEW_WORDS) {
            setErrorMessage("Review must NOT exceed 250 words.");
            return;
        }

        fetch(`${process.env.REACT_APP_API_PATH}/posts/${id}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify({
                attributes: {
                    title: postTitle,
                    image: postImage,
                    overallRating: rating,
                    private: privatePost,
                    dishID: dishId,
                    restaurant: restaurantName,
                    description: dishDescription,
                    tags: categories,
                    dishImage: dishImage,
                    author: { attributes: { username:username, } },
                },
                content: postText,
            }),
        })
            .then(res => res.json())
            .then(result => {
                if (result?.id) {
                    navigate(`/reviewPost/${result.id}`);
                } else {
                    setErrorMessage("Error: Could not update post.");
                }
            })
            .catch(err => {
                console.error("Error saving post:", err);
                setErrorMessage("Error updating post. Please try again.");
            });
    };

    const handleBack = e => {
        e.preventDefault();
        navigate(-1);
    };


    const Popup = ({ message, onClose }) => {
        if (!message) return null; // Don't render if there's no message
        return (
            <div className="popup">
                <div className="popup-content">
                    <p>{message}</p>
                    <button className="close-button" onClick={onClose}>
                        Okay
                    </button>
                </div>
            </div>
        );
    };

    const uploadPicture = e => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) return;

        if (!['image/png', 'image/jpeg'].includes(file.type) || file.size > MAX_FILE_SIZE) {
            setErrorMessage("Only PNG/JPEG under 1MB allowed.");
            return;
        }

        const formData = new FormData();
        formData.append("uploaderID", sessionStorage.getItem("user"));
        formData.append("attributes", JSON.stringify({}));
        formData.append("file", file);

        fetch(`${process.env.REACT_APP_API_PATH}/file-uploads`, {
            method: "POST",
            headers: { Authorization: "Bearer " + sessionStorage.getItem("token") },
            body: formData,
        })
            .then(res => res.json())
            .then(res => {
                let url;
                if (res.attributes?.image?.startsWith("http")) {
                    url = res.attributes.image;
                } else {
                    url = `https://webdev.cse.buffalo.edu${res.path}`;
                }
                console.log("New image uploaded, URL:", url);
                setPostImage(url);
                setErrorMessage("");
            })
            .catch(error => {
                console.error("Error uploading image:", error);
                setErrorMessage("Error uploading image. Please try again.");
            });
    };

    const handleTitleChange = e => {
        const words = e.target.value.split(/\s+/);
        if (words.length <= MAX_TITLE_WORDS) setPostTitle(e.target.value);
        else setErrorMessage("Title cannot exceed 15 words.");
    };

    const handleReviewChange = e => {
        const words = e.target.value.split(/\s+/);
        if (words.length <= MAX_REVIEW_WORDS) setPostText(e.target.value);
        else setErrorMessage("Review must NOT exceed 250 words.");
    };

    const handlePrivacy = (e) => {
        setPrivatePost(!privatePost);
        if (setPrivatePost == true) {
            <img className="LockingPhoto" src={lock} alt="Locking"></img>
        }
    };


    return (
        <div>
            {!isLoaded ? (
                <div className="loading">Loading...</div>
            ) : (
                <>
                    <Popup message={errorMessage} onClose={() => setErrorMessage("")} />
                    <head>
                        <link rel="preconnect" href="https://fonts.googleapis.com" />
                        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                        <link href="https://fonts.googleapis.com/css2?family=Fredoka:wght@500&display=swap" rel="stylesheet" />
                    </head>
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <h2 className="post-view-title">Editing Post</h2>
                    <div className="container">
                        {/* <label className="privacy-label" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                                type="checkbox"
                                checked={privatePost}
                                onChange={handlePrivacy}
                            />
                            {privatePost ?
                                <div>
                                    <img className="Locking_Photo" src={lock} alt="Locking"></img>
                                    Private (Only Followers)
                                </div>

                                :
                                <div>
                                    <img className="Locking_Photo" src={unlock} alt="Locking"></img>
                                    Public (Everyone)</div>
                            }
                        </label> */}
                        <form className="together" onSubmit={handleSave}>
                            <div className="PostForm">
                                <label>Title <span className="required">*</span></label>
                                <input className="Title" type="text" placeholder="Enter Title" value={postTitle} onChange={handleTitleChange} />
                                <label>Image</label>
                                {!postImage ? (
                                    <input className="withoutImage" type="file" accept="image/*" onChange={uploadPicture} />
                                ) : (
                                    <div className="image-preview">
                                        <img
                                            src={postImage}
                                            alt="Post"
                                            style={{
                                                maxWidth: "300px",
                                                maxHeight: "200px",
                                                objectFit: "contain",
                                                border: "1px solid #ddd",
                                                borderRadius: "4px",
                                                padding: "4px",
                                                marginBottom: "10px"
                                            }}
                                            onError={(e) => {
                                                console.error("Error loading image:", e);
                                                e.target.onerror = null;
                                                e.target.src = `${process.env.PUBLIC_URL}/placeholder.jpg`;
                                            }}
                                        />
                                        <div style={{ display: "flex", gap: "10px" }}>
                                            <button
                                                type="button"
                                                onClick={() => setPostImage("")}
                                                style={{
                                                    padding: "6px 12px",
                                                    backgroundColor: "#f8d7da",
                                                    color: "#721c24",
                                                    border: "1px solid #f5c6cb",
                                                    borderRadius: "4px",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Remove Image
                                            </button>
                                            <label
                                                style={{
                                                    padding: "6px 12px",
                                                    backgroundColor: "#e2e3e5",
                                                    color: "#383d41",
                                                    border: "1px solid #d6d8db",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    display: "inline-block"
                                                }}
                                            >
                                                Change Image
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={uploadPicture}
                                                    style={{ display: "none" }}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                )}
                                <div className="rating">
                                    <label>Rating <span className="required">*</span></label>
                                    <Star rating={rating} onRatingChange={handleRatingChange} />
                                </div>
                                <label>Review <span className="required">*</span></label>
                                <textarea className="CommentBox" placeholder="Enter review" value={postText} rows="10" cols="70" onChange={handleReviewChange} />
                                <div className="button-container">
                                    <button className="cancelEdit" type="button" onClick={handleBack}>Back</button>
                                    <button className="update" type="submit">Update</button>
                                </div>
                            </div>
                            <div className="Information" style={{
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                padding: '20px',
                                marginLeft: '20px',
                                backgroundColor: '#f9f9f9'
                            }}>
                                <h1 style={{ marginTop: '0', color: '#333' }}>{restaurantName || "Restaurant"}</h1>
                                <h2 style={{ color: '#555' }}>{dishName || "Dish"}</h2>
                                {categories && categories.length > 0 && (
                                    <div className="tags" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginBottom: '15px' }}>
                                        {categories.map((c, i) => (
                                            <span key={i} className="dish-tag" style={{
                                                backgroundColor: '#e9ecef',
                                                color: '#495057',
                                                padding: '3px 8px',
                                                borderRadius: '4px',
                                                fontSize: '14px'
                                            }}>
                                                {c}
                                            </span>
                                        ))}
                                    </div>
                                )}
                                <p className="dish-description" style={{ marginBottom: '15px' }}>{dishDescription || "No description available"}</p>
                                {dishImage ? (
                                    <img
                                        src={dishImage}
                                        alt={dishName}
                                        className="dish-info-image"
                                        style={{ maxWidth: '100%', borderRadius: '4px' }}
                                    />
                                ) : (
                                    <div className="no-dish-image" style={{
                                        padding: '20px',
                                        backgroundColor: '#eee',
                                        textAlign: 'center',
                                        borderRadius: '4px',
                                        color: '#777'
                                    }}>
                                        No dish image available
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                </>
            )}
        </div>
    );
};

export default EditPost;
